<template>
  <div>
    <iModal title="奖项设置" v-model="showModal" class-name="vertical-center-modal" width="600px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="form" :model="form" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem label="奖项：" prop="prize">
              <RadioGroup v-model="form.prizeLabel">
                <Radio label="">无</Radio>
                <Radio label="最具应答力"></Radio>
                <Radio label="最具活力"></Radio>
                <Radio label="最受关注"></Radio>
                <Radio label="热搜榜常驻"></Radio>
              </RadioGroup>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit()">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script> 
import { mapActions } from "vuex";

export default {
  name: "ex-prize",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editPrizeInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false,
      showModal: true,
      form: {
        // form双向绑定
        prizeLabel: "",
      },
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
  },
  created () {
    let info = this.editPrizeInfo;
    if (info) {
      this.form.prizeLabel = info.prizeLabel || '';
    }
  },
  methods: {
    ...mapActions({
      setPrizeLabel: "hostSetModule/setPrizeLabel"
    }),
    async handleSubmit (name) {
      let req = {
        joinId: this.editPrizeInfo.joinId,
        prizeLabel: this.form.prizeLabel || '无',
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.setPrizeLabel(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["form"].resetFields();
      this.$emit("close");
    },
    select (item) {
      if (item.value == 0) {
        this.time = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
/deep/ .admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

